export default {
    beforeMount(el, binding) {
      if (binding.value) {
        el.innerText = binding.value.replace(/\n/g, '<br>');
      }
    },
    updated(el, binding) {
      if (binding.value) {
        el.innerText = binding.value.replace(/\n/g, '<br>');
      }
    }
  };